import VueRouter from 'vue-router'

let vueRouter
const routerEvents = []

function registerRouteEvent (name, callback) {
  // vueRouter 存在时候注册 routerEvents 中的事件
  if (vueRouter && routerEvents.length) {
    routerEvents.forEach(({ name, callback }) => vueRouter[name].call(vueRouter, callback))
    routerEvents.splice(0, routerEvents.length)
    routerEvents.length = 0
  }

  if (!name) return
  if (!['beforeEach', 'beforeResolve', 'afterEach'].includes(name)) {
    console.warn('registerRouteEvent warning: name is illegal')
    return
  }
  if (typeof callback !== 'function') {
    console.warn('registerRouteEvent warning: callback not function')
    return
  }

  if (vueRouter) vueRouter[name].call(vueRouter, callback)
  else routerEvents.push({ name, callback })
}

function setVueRouter (router) {
  if (router instanceof VueRouter) {
    vueRouter = router
    registerRouteEvent()
  } else {
    vueRouter = null
    throw new Error('setVueRouter router not instance of VueRouter')
  }
}

function getVueRouter () {
  return vueRouter
}

export {
  registerRouteEvent,
  setVueRouter,
  getVueRouter
}
